import { getRentDate } from "./formatTime";

const getRentStatus = (rented) => {
  return rented ? "已出租" : "未出租";
};

const addSearchedField = (parkingSpaces) => {
  parkingSpaces.forEach((ps) => {
    const { number, floor, rented, lease, roomNumber } = ps;
    const renters = lease?.renters;

    const shownTexts = [
      number,
      floor,
      getRentStatus(rented),
      renters?.map((renter) => renter.name).join(",") ?? "",
      roomNumber,
      renters?.map((renter) => renter.phoneNumber ?? "無").join(",") ?? "",
      getRentDate(lease?.startDate, lease?.endDate),
    ];

    ps.searchedField = shownTexts.join(" ");
  });
};

export { getRentStatus, addSearchedField };
